var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_419_985)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.0005 0.000477601C21.7117 -0.0199131 18.4517 0.61281 15.4093 1.86196C12.367 3.1111 9.60289 4.95181 7.27735 7.27735C4.95181 9.60289 3.1111 12.367 1.86196 15.4093C0.61281 18.4517 -0.0199131 21.7117 0.000477601 25.0005C-0.0199131 28.2892 0.61281 31.5493 1.86196 34.5916C3.1111 37.634 4.95181 40.3981 7.27735 42.7236C9.60289 45.0491 12.367 46.8899 15.4093 48.139C18.4517 49.3881 21.7117 50.0209 25.0005 50.0005C28.2892 50.0209 31.5493 49.3881 34.5916 48.139C37.634 46.8899 40.3981 45.0491 42.7236 42.7236C45.0491 40.3981 46.8899 37.634 48.139 34.5916C49.3881 31.5493 50.0209 28.2892 50.0005 25.0005C50.0209 21.7117 49.3881 18.4517 48.139 15.4093C46.8899 12.367 45.0491 9.60289 42.7236 7.27735C40.3981 4.95181 37.634 3.1111 34.5916 1.86196C31.5493 0.61281 28.2892 -0.0199131 25.0005 0.000477601ZM34.7237 37.5005L12.5005 15.279L15.279 12.5005L37.5005 34.7237L34.7237 37.5005Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5 15.5L35 13L13 35L15.5 37.5L37.5 15.5Z",
    fill: "white",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_419_985"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/Error.1474f3b18f572b87350604f79528f55b.svg";
export { ForwardRef as ReactComponent };